import { request } from '../utils/request'
import { stringify } from '../utils/index'
export default {
  aiappraisal: (option) => request('v1/aiappraisal/aiappraisal' + stringify(option), option), // 重新鉴定
  reaiappraisal: (option) => request('v1/aiappraisal/reaiappraisal' + stringify(option), option), // 重新鉴定
  sumairecognition: (option) => request('v1/aiappraisal/sumairecognition' + stringify(option), option), // AI鉴定统计
  downloadaiappraisalimage: (option) => request('v1/aiappraisal/downloadaiappraisalimage' + stringify(option), option, true, false, true), // 下载鉴定记录

  getappraisaltimeoutvmss: (option) => request('v1/appraisalordertimeoutnotify/getappraisaltimeoutvmss', option), // 智能语音列表
  getinventorysbycategory: (option) => request('v1/inventory/getinventorysbycategory' + stringify(option), option), // 按品类即时库存
  gettopblandinventorys: (option) => request('v1/inventory/gettopblandinventorys' + stringify(option), option), // 按品牌即时库存
  getcategoryblandinventorys: (option) => request('v1/inventory/getcategoryblandinventorys' + stringify(option), option), // 即时库存列表

  getappraisalrooms: (option) => request('v1/appraisalroom/getappraisalrooms', option), // 查询鉴定中心列表
  getaimodels: (option) => request('v1/aiappraisal/getaimodels', option), // AI鉴定模型列表
  updateaimodel: (option) => request('v1/aiappraisal/updateaimodel', option), // AI鉴定模型列表
  configaimodel: (option) => request('v1/aiappraisal/configaimodel', option), // AI鉴定模型配置鉴定中心

  getuniqueproductcodeblacklist: (option) => request('v1/aiappraisal/getuniqueproductcodeblacklist', option), // 非商品唯一码列表
  removefromuniqueproductcodeblacklistbyid: (option) => request('v1/aiappraisal/removefromuniqueproductcodeblacklistbyid' + stringify(option), option), // 删除非商品唯一码

  getairecognitionrecords: (option) => request('v1/aiappraisal/getairecognitionrecords', option), // AI鉴定记录
  getocrrecords: (option) => request('v1/aiappraisal/getocrrecords', option), // ocr记录

  modifyuniqueproductcode: (option) => request('v1/aiappraisal/modifyuniqueproductcode' + stringify(option), option), // 修改商品唯一码
  clearuniqueproductcode: (option) => request('v1/aiappraisal/clearuniqueproductcode' + stringify(option), option), // 设置非唯一码
  getappraisalordersbyuniqueproductcode: (option) => request('v1/appraisalorder/getappraisalordersbyuniqueproductcode' + stringify(option), option) // 查询同商品唯一码列表
}
